import actionTypes from 'dashboard/actions/announcements/action-types';

export default (state = false, action) => {
  switch (action.type) {
    case actionTypes.FETCH_ANNOUNCEMENTS_SUCCESS:
      return action.draft;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/reducers/announcements/draft.js